export const postalCodeRegExp = /^[0-9]{2}-[0-9]{3}/;
export const nipRegExp = /^[0-9]{10}$/;
export const phoneRegExp =
    /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
export const countryNameRegExp = /^[a-zA-Z@]+$/;
export const passwordRegEx = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?&/<>.:;“'])[A-Za-z\d#$@!%&*?&/<>.:;“']{8,50}$/;
export const percentageArea = /^[0-9]$|^[1-9][0-9]$|^(100)$|^([0-9]){1}(\.[0-9]{1,2})?$|^([1-9][0-9])(\.[0-9]{1,2})?$/;